export default "__VITE_ASSET__BAYsWUXB__"